import { Dialog } from "ui/dialog";
import { Button } from "ui/button";

import { CampaignTemplateSummaryContent } from "containers/admin/clients/client/campaign-templates-page/campaign-template-summary-content";
import {
  type CampaignSummarySource,
  useCampaignTemplateSummary,
} from "containers/admin/clients/client/campaign-templates-page/use-campaign-template-summary";

type CampaignTemplateSummaryModalProps = {
  source: CampaignSummarySource;
  onClose: () => void;
};

export const CampaignTemplateSummaryModal = ({
  source,
  onClose,
}: CampaignTemplateSummaryModalProps) => {
  const { title, isLoading, generalFields, logicFields, creativeRows } =
    useCampaignTemplateSummary(source);

  return (
    <Dialog
      open
      onClose={onClose}
      size="xlarge"
      headline={title}
      actions={
        <Button size="large" onClick={onClose}>
          Close
        </Button>
      }
      closeOnBrowserBack={false}>
      <CampaignTemplateSummaryContent
        isLoading={isLoading}
        generalFields={generalFields}
        logicFields={logicFields}
        creativeRows={creativeRows}
      />
    </Dialog>
  );
};
